import Seo from '../components/Seo';

export default function AvisoLegal() {
  return (
    <>
      <Seo
        title="Aviso Legal"
        description="Información legal del titular del sitio web barcabrero.com — Rumoroso56 S.L., CIF B-39598716, Torrelavega (Cantabria). Conforme a la Ley 34/2002 (LSSI-CE)."
        path="/aviso-legal"
      />
      <article className="sec legal-page" data-testid="aviso-legal">
        <p className="eyebrow rv">Información legal</p>
        <h1 className="D D-lg rv" style={{ marginBottom: '1.5rem' }}>Aviso Legal</h1>
        <p className="lead rv" style={{ marginBottom: '2.5rem' }}>
          De conformidad con la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se facilita la siguiente información:
        </p>

        <div className="legal-body rv">
          <h2>1. Datos identificativos del titular</h2>
          <dl className="legal-dl">
            <dt>Denominación social</dt><dd>Rumoroso56, S.L.</dd>
            <dt>Nombre comercial</dt><dd>Bar Cabrero</dd>
            <dt>CIF</dt><dd>B-39598716</dd>
            <dt>Domicilio social</dt><dd>C/ Pedro Lorenzo Molleda 3, bajo · 39300 Torrelavega · Cantabria · España</dd>
            <dt>Local del bar</dt><dd>C/ Julián Ceballos 19 · 39300 Torrelavega · Cantabria · España</dd>
            <dt>Teléfono</dt><dd><a href="tel:+34654233407">+34 654 23 34 07</a></dd>
            <dt>Correo electrónico</dt><dd><a href="mailto:info@barcabrero.com">info@barcabrero.com</a></dd>
            <dt>Sitio web</dt><dd><a href="https://barcabrero.com" target="_blank" rel="noopener noreferrer">https://barcabrero.com</a></dd>
          </dl>

          <h3 style={{ marginTop: '1.75rem' }}>Diseño, desarrollo y mantenimiento web</h3>
          <dl className="legal-dl">
            <dt>Responsable técnico</dt><dd>Tanuj Goswami — Eolas Prints</dd>
            <dt>Sitio web</dt><dd><a href="https://eolasprints.com" target="_blank" rel="noopener noreferrer">eolasprints.com</a></dd>
            <dt>Teléfono</dt><dd><a href="tel:+34942735955">+34 942 73 59 55</a></dd>
          </dl>

          <h2>2. Objeto</h2>
          <p>
            El presente sitio web tiene como finalidad informar sobre la actividad de hostelería desarrollada por Rumoroso56 S.L. bajo el nombre comercial <em>Bar Cabrero</em>, así como facilitar la comunicación con los clientes. No se realizan ventas en línea ni se gestionan reservas a través del sitio: los pedidos para llevar y consultas se canalizan por WhatsApp o teléfono.
          </p>

          <h2>3. Condiciones de uso</h2>
          <p>
            El acceso y la navegación por el sitio web atribuyen la condición de usuario e implican la aceptación plena de las condiciones publicadas en cada momento. El usuario se compromete a utilizar el sitio conforme a la ley, la buena fe y el orden público, absteniéndose de utilizarlo con fines o efectos ilícitos o lesivos para terceros.
          </p>

          <h2>4. Propiedad intelectual e industrial</h2>
          <p>
            Todos los contenidos del sitio web (textos, fotografías, ilustraciones, logotipos, marcas, código y diseño) son titularidad de Rumoroso56 S.L. o se utilizan con la debida autorización. Queda prohibida la reproducción, distribución, comunicación pública o transformación sin el consentimiento expreso del titular, salvo los usos permitidos por la legislación vigente.
          </p>
          <p>
            <em>Bar Cabrero</em> es una denominación comercial utilizada por Rumoroso56 S.L. Cualquier uso no autorizado de la marca o de los signos distintivos del bar podrá ser perseguido por las vías legales correspondientes.
          </p>

          <h2>5. Enlaces a sitios de terceros</h2>
          <p>
            El sitio puede contener enlaces a páginas de terceros (Google Maps, Instagram, WhatsApp, OpenStreetMap, entre otros) que Rumoroso56 S.L. no controla. La inclusión de estos enlaces no implica conformidad con sus contenidos ni con sus políticas de privacidad. El titular declina cualquier responsabilidad sobre la información, productos o servicios accesibles desde dichos sitios.
          </p>

          <h2>6. Exclusión de garantías y responsabilidad</h2>
          <p>
            Rumoroso56 S.L. realiza los mayores esfuerzos para mantener el sitio operativo, actualizado y libre de errores, pero no garantiza la disponibilidad continua del servicio ni la ausencia total de interrupciones, virus o elementos lesivos. El uso del sitio se realiza bajo la responsabilidad del usuario.
          </p>
          <p>
            Los horarios y carta publicados pueden estar sujetos a cambios por necesidades operativas. La información mostrada tiene carácter orientativo; ante cualquier duda recomendamos confirmar por teléfono.
          </p>

          <h2>7. Protección de datos personales</h2>
          <p>
            El tratamiento de datos personales recogidos a través del sitio se regula por la <a href="/politica-privacidad">Política de Privacidad</a>, que forma parte integrante de este Aviso Legal. Para el uso de cookies, consulte la <a href="/politica-cookies">Política de Cookies</a>.
          </p>

          <h2>8. Legislación aplicable y jurisdicción</h2>
          <p>
            El presente Aviso Legal se rige por la legislación española. Para la resolución de cualquier controversia derivada del acceso o uso del sitio, las partes se someten a los Juzgados y Tribunales de Torrelavega (Cantabria), con renuncia expresa a cualquier otro fuero que pudiera corresponderles, salvo en aquellos casos en los que la normativa imponga un fuero distinto.
          </p>

          <h2>9. Modificaciones</h2>
          <p>
            Rumoroso56 S.L. se reserva el derecho a modificar el presente Aviso Legal cuando lo considere oportuno, así como su sitio web, sin previo aviso. Cualquier cambio será publicado en esta misma página, recomendándose su consulta periódica.
          </p>

          <p className="legal-updated">Última actualización: 6 de febrero de 2026.</p>
        </div>
      </article>
    </>
  );
}
